import clsx from 'clsx';
import type { ReactNode } from 'react';

/**
 * The card grid. Columns come from the available width, not a breakpoint
 * table: as many cards as fit at their minimum width, so a wide screen shows
 * five across, a tablet two or three, a phone one — and nothing ever scrolls
 * sideways.
 */
export function ModuleGrid({
  children,
  label,
  dense = false,
}: {
  children: ReactNode;
  /** Names the list for assistive technology. */
  label: string;
  /** Sub-module cards are smaller, so more fit. */
  dense?: boolean;
}) {
  return (
    <ul
      aria-label={label}
      className={clsx(
        'grid gap-4',
        dense
          ? '[grid-template-columns:repeat(auto-fill,minmax(min(100%,15rem),1fr))]'
          : '[grid-template-columns:repeat(auto-fill,minmax(min(100%,16.5rem),1fr))]',
      )}
    >
      {children}
    </ul>
  );
}

export function ModuleGridItem({ children }: { children: ReactNode }) {
  return <li className="min-w-0">{children}</li>;
}
